import { QuickArt } from './../../../../../shared/sdk/models/QuickArt';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';
import { ICssShadow } from '../ICssShadow.interface';

export class SeShapeConfig extends SeCommonConfig implements IBaseSEConfig {
  // settings just for this element
  public imageURL = '';
  public SeType = 'SeShape';
  public modelRef: QuickArt;
  public fillColor = 'rgba(0,0,0,1)';
  public strokeColor = 'rgba(40,255,40,1)';
  public strokeWidth = .5;
  public strokeOpacity = 1;
  public dropShadows: Array<ICssShadow> = new Array<ICssShadow>();
  public poster = '';

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.imageURL = this.imageURL; // and any custom props
    obj.SeType = this.SeType;
    obj.modelRef = this.modelRef;
    obj.fillColor = this.fillColor;
    obj.strokeColor = this.strokeColor;
    obj.strokeWidth = this.strokeWidth;
    obj.strokeOpacity = this.strokeOpacity;
    obj.dropShadows = this.dropShadows;
    obj.poster = this.poster;

    obj.files = [];
    if (obj.modelRef) {
      obj.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.FilenameOnServer,
        hash: this.modelRef.hash
      });
    }

    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings
    this.imageURL = _.get(obj, 'imageURL', ''); // get val in safe way with defalut
    this.SeType = _.get(obj, 'SeType', 'SeShape');
    this.modelRef = _.get(obj, 'modelRef', null);
    this.fillColor = _.get(obj, 'fillColor', 'rgba(0,0,0,1)');
    this.strokeColor = _.get(obj, 'strokeColor', 'rgba(200,0,0,1)');
    this.strokeWidth = _.get(obj, 'strokeWidth', 0);
    this.strokeOpacity = _.get(obj, 'strokeOpacity', 1);
    this.dropShadows = _.get(obj, 'dropShadows', new Array<ICssShadow>());
    this.poster = _.get(obj, 'poster', '');

    // override some props that werer filled in by super call
    this.sizeInBytes = _.get(obj, 'modelRef.FileSize', 0);

    this.files = [];
    if (this.modelRef) {
      this.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.FilenameOnServer,
        hash: this.modelRef.hash
      });
    }

  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-shape/se-shape-config.class.ts